import { useState, FC } from 'react';
import CardList from './CardList';
import { Typography, Grid } from '@material-ui/core';
import Search from './Search';

const References: FC = () => {
  const [searchTerm, setSearchTerm] = useState('');
  const [filter, setFilter] = useState('');

  return (
    <div>
      <Typography variant="h3" align="left" gutterBottom>
        Reference Architectures
      </Typography>
      <Grid container alignItems="center">
        <Grid item xs={12}>
          <Search setSearchTerm={setSearchTerm} setFilter={setFilter} />
        </Grid>
        <Grid item xs={12}>
          <CardList searchTerm={searchTerm} filter={filter} />
        </Grid>
      </Grid>
    </div>
  );
};

export default References;
